import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveAssessmentType } from './index';

// Api's
import { assessmentTypeApi } from '../../api';
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';

export function* getAssessmentTypeSaga() {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      assessmentTypeApi.getDomain
    );

    if (response.data.result) {
      yield put(saveAssessmentType(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveAssessmentType(null, true, resultError.messagesDataError));
    }
  }
}

